export const TIPO_RELACION_FLUJO_TESORERIA = {
  SIN_RELACION: 0,
  FACTURA: 1,
  PRESTAMO: 2,
  DEVOLUCION: 3,
  TICKET: 4,
} as const

export type TipoRelacionFlujoTesoreriaType =
  (typeof TIPO_RELACION_FLUJO_TESORERIA)[keyof typeof TIPO_RELACION_FLUJO_TESORERIA]
